<template>
  <v-app-bar
    app
    flat
    :clipped-left="isClippedLeft"
    :clipped-right="isClippedRight"
    v-if="isVisibleHeader"
    v-bind="bindStyle"
    :dense="isDense"
    :prominent="isProminent"
    :hide-on-scroll="isHideOnScroll"
    :shrink-on-scroll="isShrinkOnScroll"
  >
    <v-sheet
      color="transparent"
      v-if="isClippedOver || $vuetify.breakpoint.mdAndDown"
    >
      <v-list-item class="pl-0">
        <v-list-item-avatar tile>
          <vuse-logo class="primary--text" size="40" />
        </v-list-item-avatar>
        <v-list-item-content v-if="$vuetify.breakpoint.mdAndUp">
          <v-list-item-title class="text-h6 primary--text"
            >Vuse Admin</v-list-item-title
          >
        </v-list-item-content>
        <v-list-item-action v-if="$vuetify.breakpoint.lgAndUp">
          <v-btn
            @click.stop="toggleMiniVariant"
            small
            fab
            :class="!bindStyle.color ? 'neu-glow' : ''"
          >
            <v-icon
              :color="!bindStyle.color ? 'primary' : bindStyle.color"
              v-if="isMinSideNav"
              >double_arrow</v-icon
            >
            <v-icon
              :color="!bindStyle.color ? 'primary' : bindStyle.color"
              v-else
              >menu_open</v-icon
            >
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-sheet>
    <div v-if="$vuetify.breakpoint.lgAndUp">
      <!-- toggle Mini variant -->
      <v-btn
        @click.stop="toggleMiniVariant"
        small
        fab
        :class="!bindStyle.color ? 'neu-glow' : ''"
        v-if="!isClippedOver"
      >
        <v-icon
          :color="!bindStyle.color ? 'primary' : bindStyle.color"
          v-if="isMinSideNav"
          >double_arrow</v-icon
        >
        <v-icon :color="!bindStyle.color ? 'primary' : bindStyle.color" v-else
          >menu_open</v-icon
        >
      </v-btn>
      <!-- Chat APP -->
    </div>
    <v-spacer />
    <v-btn
      v-if="$vuetify.breakpoint.mdAndDown"
      class="mr-3"
      small
      fab
      :class="!bindStyle.color ? 'neu-glow' : ''"
      @click="handleSidenavDrawer()"
    >
      <v-icon :color="!bindStyle.color ? 'primary' : bindStyle.color"
        >menu</v-icon
      >
    </v-btn>
    <v-btn
      class="mr-3"
      small
      fab
      :class="!bindStyle.color ? 'neu-glow' : ''"
      @click="handleSettingsDrawer()"
    >
      <v-icon :color="!bindStyle.color ? 'primary' : bindStyle.color">
        settings
      </v-icon>
    </v-btn>
<!--    <v-menu offset-y close-on-click>-->
<!--      <template v-slot:activator="{ on }">-->
<!--        <v-btn v-on="on" small fab class="neu-glow mr-3">-->
<!--          <v-avatar size="30">-->
<!--            <v-img :src="currentLocaleImg"></v-img>-->
<!--          </v-avatar>-->
<!--        </v-btn>-->
<!--      </template>-->

<!--      <v-list dense class="neu-glow">-->
<!--        <v-list-item-->
<!--          v-for="(item, index) in langs"-->
<!--          :key="index"-->
<!--          @click="handleInternationalization(item.value)"-->
<!--        >-->
<!--          <v-list-item-avatar tile class="with-radius" size="25">-->
<!--            <v-img :src="item.img"></v-img>-->
<!--          </v-list-item-avatar>-->
<!--          <v-list-item-title>{{ item.text }}</v-list-item-title>-->
<!--        </v-list-item>-->
<!--      </v-list>-->
<!--    </v-menu>-->
    <!-- User Profile Menu -->
    <v-menu offset-y min-width="160">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" icon class="mr-0">
          <v-avatar size="40" v-if="bindStyle.color">
            <v-img :src="authUser.avatar"></v-img>
          </v-avatar>
          <vuse-avatar size="40" :src="authUser.avatar" v-else />
        </v-btn>
      </template>
      <v-list nav dense class="neu-glow-primary with-radius">
        <template v-for="(item, index) in items">
          <v-divider v-if="item.divider" :key="index"></v-divider>
          <v-list-item :key="index" @click="() => {
            if(item.id == 'settings'){
              $router.push('/setting/user')
            }
            if(item.id == 'change-password'){
              openDialog();
            }
          }" v-else>
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template>
          <v-divider></v-divider>
          <v-list-item >
            <v-list-item-icon>
              <v-icon @click="logout">power_settings_new</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title style="cursor: pointer"  @click="logout">Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>

    <v-dialog
        v-model="dialog"
        max-width="500"
        persistent
    >
      <v-card class="rounded-lg">
        <v-card-title class="d-flex justify-center">
          Thay đổi mật khẩu
        </v-card-title>

        <v-card-text>
          <v-row class="mt-5">
            <v-col cols="12">
              <v-text-field
                  :type="show ? 'text' : 'password'"
                  background-color="#EDF2F7"
                  filled
                  label="Mật khẩu cũ"
                  v-model="changePasswordData.password_old"
                  placeholder="Mật khẩu cũ"
                  @click:append="show = !show"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  :type="show1 ? 'text' : 'password'"
                  background-color="#EDF2F7"
                  filled
                  label="Mật khẩu"
                  v-model="changePasswordData.password"
                  placeholder="Mật khẩu"
                  @click:append="show1 = !show1"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  :type="show2 ? 'text' : 'password'"
                  background-color="#EDF2F7"
                  filled
                  label="Xác nhận mật khẩu"
                  v-model="changePasswordData.password_confirmation"
                  placeholder="Xác nhận mật khẩu"
                  @click:append="show2 = !show2"
                  :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="6" class="d-flex justify-end">
                  <v-btn
                      @click="dialog = false"
                  >
                    Hủy
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn
                      color="primary"
                      @click="changePassword"
                  >
                    Lưu
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app-bar>

</template>

<script>
import { mapGetters } from "vuex";
import { availableLocale } from "@/config/locale";
import { LOGOUT, CHANGE_PASSWORD_USER } from "@/store/modules/auth";

export default {
  props: {
    handleSettingsDrawer: Function,
  },
  data() {
    return {
      show: false,
      show1: false,
      show2: false,
      dialog: false,
      changePasswordData: {
        password_old: null,
        password: null,
        password_confirmation: null
      },
      authUser: {
        name: "Alice Blue",
        firstname: "Alice",
        lastname: "Blue",
        email: "aliceblue@example.com",
        avatar: `/static/ali.jpg`,
        mood: "Vuse - Powerful VuejS admin template.",
        status: {
          color: "success",
          icon: "check_circle",
        },
      },
      items: [
        // { icon: "person", text: "Profile" },
        { icon: "account_balance_wallet", text: "Thay đổi mật khẩu", id: 'change-password' },
        // { icon: "inbox", text: "Inbox" },
        { divider: true },

      ],
      langs: availableLocale,
    };
  },
  mounted(){
    if(this.hasPermissions('List role') || this.hasPermissions('List user')){
      this.items.push({ icon: "settings", text: "Danh sách admin", id: 'settings'});
    }
  },
  computed: {
    activeItemStyle: (state) => state.activeMenuStyle,
    ...mapGetters("navigations", [
      "isVisibleHeader",
      "isSidenavPostionRight",
      "isClippedOver",
      "isMinSideNav",
      "isDense",
      "isProminent",
      "isHideOnScroll",
      "isShrinkOnScroll",
      "isFloating",
    ]),
    ...mapGetters("scheme", ["header"]),
    ...mapGetters(["locale"]),
    isClippedRight() {
      return this.isClippedOver && this.isSidenavPostionRight;
    },
    isClippedLeft() {
      return this.isClippedOver && !this.isSidenavPostionRight;
    },
    bindStyle() {
      const { color, dark, classes } = this.header;
      return {
        class: {
          "vuse-header": true,
          "with-radius": true,
          [classes]: true,
          "mx-6 mt-3": this.isFloating && !this.isClippedOver,
        },
        dark,
        color,
      };
    },
    currentLocaleImg() {
      return this.langs.find((item) => item.value === this.locale).img;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch(LOGOUT);
      this.$router.push({name:"login"})
    },
    toggleMiniVariant() {
      this.$store.dispatch("navigations/setMiniVariant");
    },
    handleSidenavDrawer() {
      this.$store.dispatch("navigations/setSidenavVisibility");
    },
    handleInternationalization(value) {
      this.$store.dispatch("setLocale", value);
    },
    openDialog(){
      this.changePasswordData.password_old = null;
      this.changePasswordData.password = null;
      this.changePasswordData.password_confirmation = null;
      this.dialog = true;
    },
    async changePassword(){
      let _this = this;
      await this.$store.dispatch(CHANGE_PASSWORD_USER, this.changePasswordData).then(function(data){
        if (data.status == 1) {
            _this.$toasted.success('Cập nhật thành công!', {
                duration:1000,
                position:'top-center'
            })
            _this.dialog = false;
            _this.logout()
        }else{
          if(data.errors){
            alert(data.errors)
          }else if(data.message){
            alert(data.message)
          }else{
            _this.$toasted.success('Cập nhật không thành công đã có lỗi xảy ra!', {
                duration:1000,
                position:'top-center'
            })
            _this.dialog = false;
          }
        }
      });
    }
  },
};
</script>
